import {useWorkspace} from '../../../../../../../contexts/WorkspaceContext'
import AssigneeDropdown from '../../../../../../app/AssigneeDropdown/AssigneeDropdown'
import Avatar from '../../../../../../ui/Avatar/Avatar'
import ButtonRound from '@/components/ui/ButtonRound/ButtonRound'
import AvatarPlaceholderIcon from '@/assets/icons/icon-avatar-placeholder.svg?react'
import {getMemberDisplayName} from '@/utils/memberDisplayName'

interface TaskModalAssignedProps {
    memberId: string | null
    onMemberSelect?: (memberId: string | null) => void
}

// The task modal only opens once members have initialized when the task has an assignee
// (WorkspaceTaskModalRoute's readiness gate, SCD-916), so getMember resolves here — no need to
// guard against the assignee flashing "Unassigned" before the members list loads.
const TaskModalAssigned = ({memberId, onMemberSelect}: TaskModalAssignedProps) => {
    const {getMember} = useWorkspace()
    const currentMember = memberId ? getMember(memberId) : null

    const displayName = currentMember ? getMemberDisplayName(currentMember) : 'Unassigned'

    const icon = currentMember
        ? <Avatar title={displayName} color={currentMember.color} avatar={currentMember.avatarImage} size="small"/>
        : <AvatarPlaceholderIcon/>

    return (
        <AssigneeDropdown assigneeId={memberId} onSelect={(id) => onMemberSelect?.(id)}>
            {({onClick}) => (
                <ButtonRound icon={icon} onClick={onClick}>
                    {displayName}
                </ButtonRound>
            )}
        </AssigneeDropdown>
    )
}

export default TaskModalAssigned
